<h4  class="text-center" mat-dialog-title>😎 You can upload your invoice 🧾</h4>
    <div class="col-12 text-center">
        <button type="button"  (click)="openOfferDetail()" style="background-color: rgb(167, 167, 167);border-color: rgb(167, 167, 167);" class="btn  btn-secondary btn-template ">I'll be back</button>
        <button type="button"  (click)="openInvoice()"  class="btn  btn-secondary button-top btn-template ml-3" >Yes</button>
    </div>